import React, { useState } from 'react'
import { connect } from 'react-redux'
import { css } from 'styled-components'
import PropTypes from 'prop-types'
import NewButton from 'components/common/Button/Button'
import { Button } from '@material-ui/core'
import { DescriptionOutlined } from '@material-ui/icons'
import { injectIntl } from 'react-intl'
import { ReactComponent as ExportIcon } from 'assets/img/export-icon.svg'
import { exportToCsv } from 'reducers/common/exportCSV/reducer'
import withPromise from 'helpers/withPromise'
import { BUTTON_TYPE_SECONDARY } from './Button/constants'

function ExportButton(props) {
  const [isDisableExportButton, setIsDisableExportButton] = useState(false)

  const onExportBtnClick = () => {
    const {
      params,
      exportToCsv,
      intl: { formatMessage },
    } = props
    params.fileDownloadFailureMessage = formatMessage({
      id: 'file_download_failure',
    })

    setIsDisableExportButton(true)
    withPromise(exportToCsv, params).then(() => setIsDisableExportButton(false))
  }

  const {
    intl: { formatMessage },
    isNewDesign,
    className,
  } = props

  return isNewDesign ? (
    <NewButton
      disabled={isDisableExportButton}
      onClick={onExportBtnClick}
      startIcon={<ExportIcon />}
      type={BUTTON_TYPE_SECONDARY}
      customStyles={css`
        line-height: 22px;
        font-size: 16px;
        margin-right: 8px;
        text-transform: none;
      `}>
      {formatMessage({ id: 'export_csv' })}
    </NewButton>
  ) : (
    <Button
      className={className || ''}
      disabled={isDisableExportButton}
      onClick={onExportBtnClick}
      variant="contained"
      color="primary"
      classes={{ root: 'export-button' }}>
      <DescriptionOutlined />
    </Button>
  )
}

ExportButton.propTypes = {
  params: PropTypes.object.isRequired,
}

export default connect(null, {
  exportToCsv,
})(injectIntl(ExportButton))
